import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useRouter } from '@/@core/utils/utils';

export default function useUsersList() {
  const refUserListTable = ref(null);
  const { route } = useRouter();
  // Table Handlers
  const breadcrumbs = [
    { path: '/home/multimedia/upload-dalet', name: 'Upload vào Dalet' },
    { path: '/home/multimedia/dalet', name: 'Đến cổng điện tử' },
    // { path: '/home/multimedia/editor-network', name: 'Đến mạng biên tập' },
    // { path: '/home/multimedia/vov5', name: 'VOV5' },
    // { path: '/home/multimedia/vovnews', name: 'VOV News' },
  ];
  const loading = ref(false);
  const perPage = ref(50);
  const totalEntries = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const positionFilter = ref(null);
  const planFilter = ref(null);
  const statusFilter = ref(null);
  const isPaginate = ref(1);
  const itemsData = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    };
  });

  const resolveActiveClass = (item) => {
    if (route.value.path === item.path) {
      return 'active';
    }
    return '';
  }

  return {
    loading,
    breadcrumbs,
    resolveActiveClass,

    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    itemsData,

    // Extra Filters
    positionFilter,
    planFilter,
    statusFilter,
  };
}
